import { render, staticRenderFns } from "./DateFieldItem.vue?vue&type=template&id=a9809804&scoped=true"
import script from "./DateFieldItem.vue?vue&type=script&lang=ts"
export * from "./DateFieldItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9809804",
  null
  
)

export default component.exports